import React, { useMemo } from 'react';
import format from 'date-fns/format';
import { toast } from 'components/Shared/Toast'
import { useTranslation } from 'react-i18next';

import { parseDate } from 'utils';
import { Button, UncontrolledTooltip } from 'reactstrap';

const dateFormat = 'yyyy-MM-dd';

const voboStatusObj = {
    'sent': {
        icon: 'exclamation-triangle',
        color: 'warning'
    },
    'approved': {
        icon: 'check',
        color: 'success'
    },
    'rejected': {
        icon: 'times',
        color: 'danger'
    }
}

function Properties({ contract }) {

    const { t } = useTranslation();

    function copyToClipboard() {
        navigator.clipboard.writeText(`notificaciones-${contract?._id}@email.trato.io`);
        toast.success(t('common.copied_clipboard'))
    };

    return (
        <div className="p-3">
            <h4>{t('records.sidebar.properties')}</h4>
            <div className="properties-listing">
                <label id="name">{t('contracts.properties.name')}:</label>
                <p>{contract.documentId} - {contract.name}</p>

                <label id="user">{t('contracts.properties.owner')}:</label>
                <p>{contract.user?.givenName} {contract.user?.familyName}</p>

                <label id="creator">{t('contracts.properties.creator')}:</label>
                <p>{contract.creator?.givenName} {contract.creator?.familyName}</p>

                <label id="participants">{t('contracts.properties.participants')}:</label>
                <ul>
                    {
                        contract.participants?.map((participant, index) => (

                            <li key={index}>
                                {t(`sign.participants.${participant.obligation}`)}: <br />
                                {participant.name} {participant.obligation === 'individual' ? participant.last_name : `- ${participant.representative}`}
                                -   <a href={`mailto:${participant.email}?cc=notificaciones-${contract._id}@email.trato.io`}>
                                    {participant.email}
                                </a>
                            </li>

                        ))
                    }
                </ul>

                <label id="status">{t('contracts.properties.status')}:</label>
                <p><i>{t(`contracts.status.${contract.status}`)}</i></p>

                <label id="createdAt">{t('contracts.properties.createdAt')}:</label>
                <p>{parseDate(contract.createdAt, dateFormat)}</p>

                <label id="expiryEndDate">{t('contracts.properties.expiryEndDate')}:</label>
                {contract.expiryUndefined ?
                    <p>{t('contracts.properties.expiryUndefined')}</p>
                    : <p> {parseDate(contract.expiryEndDate, dateFormat)}</p>
                }

                <label> {t('contracts.properties.reply_link')}:</label>
                <div className="d-flex">
                    <a href={`mailto:notificaciones-${contract._id}@email.trato.io`}>notificaciones-{contract._id}@email.trato.io</a>
                    <div className="ml-auto" >
                        <UncontrolledTooltip target="copyToClipboard">{t('contracts.timeline.copy_to_clipboard')}</UncontrolledTooltip>
                        <Button color="default" id="copyToClipboard" onClick={copyToClipboard}>
                            <i className="fas fa-copy text-primary"></i>
                        </Button>
                    </div>
                </div>

                <label id="vobo">{t('contracts.properties.vobo')}:</label>
                <ul className="" style={{ listStyleType: 'none', paddingLeft: 10, margin: 0 }}>
                    {contract.vobo?.map(vobo =>
                        <Vobo vobo={vobo} index={vobo._id}></Vobo>
                    )}
                </ul>
            </div>
        </div>
    )
};

export function Vobo({ vobo }) {
    const { t } = useTranslation();

    const voboStatus = voboStatusObj[vobo.status];

    return (
        <li >
            <UncontrolledTooltip target={'vobo-label'}>
                {t(`editor.collaboration.${vobo.status}`)}
            </UncontrolledTooltip>
            <i
                className={`fas fa-${voboStatus.icon} text-${voboStatus.color}`}
                id="vobo-label"
            />{' '}
            {vobo.user?.givenName} {vobo.user?.familyName} {' '}
            {vobo.userGroup?.name} {' '}
            {vobo.dateStartVoBo && <span>- {parseDate(vobo.dateStartVoBo)}</span>}
        </li>
    )
}

export default Properties;